import { GridColDef } from "@mui/x-data-grid";

const agencyColumnDef: GridColDef[] = [
    { field: 'agency_name', headerName: 'Agency Name', width: 200 },
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'agency_contact', headerName: 'Agency Contact', width: 200 },
    { field: 'agency_address', headerName: 'Agency Address', width: 200 },
    { field: 'is_active', headerName: 'Status', width: 50 },
    { field: 'created_date', headerName: 'Created Date', width: 200 },
    { field: 'created_by', headerName: 'Created By', width: 200 }
];

export default agencyColumnDef;